import { UseQueryResult, useMutation, useQuery } from "@tanstack/react-query";
import {
  findAllContents,
  findAllDateVolunteer,
  updateContents,
  updateDateVolunteer,
  uploadMapImage,
  uploadSubContentImage,
  uploadContentImage,
} from "./content.service";
import { Content, DateVolunteer, UploadContent } from "./content.type";

export enum KeyQueryContent {
  getallContent = "getallContent",
  getallDateVolunteer = "getallDateVolunteer",
}

export const useGetAllContent = (): UseQueryResult<Content[]> => {
  return useQuery([KeyQueryContent.getallContent], () => findAllContents());
};

export const useGetAllDateVolunteer = (): UseQueryResult<DateVolunteer[]> => {
  return useQuery([KeyQueryContent.getallDateVolunteer], () =>
    findAllDateVolunteer()
  );
};

export const useUpdateContents = () => {
  return useMutation({
    mutationFn: (contents: Content[]) => updateContents(contents),
  });
};

export const useUpdateDateVolunteer = () => {
  return useMutation({
    mutationFn: (contents: DateVolunteer[]) => updateDateVolunteer(contents),
  });
};

export default function useUploadMapImage() {
  return useMutation({
    mutationFn: (payload: UploadContent) => uploadMapImage(payload),
  });
}

export function useUploadSubContentImage() {
  return useMutation({
    mutationFn: (payload: UploadContent) => uploadSubContentImage(payload),
  });
}

export function useUploadContentImage() {
  return useMutation({
    mutationFn: (payload: UploadContent) => uploadContentImage(payload),
  });
}
